module.exports = __webpack_public_path__ + "img/537-42dfb3.png";